import { MatDialogModule } from '@angular/material/dialog';
import { ApplicationRoutingModule } from './application-routing.module';
import { CommonModule } from '@angular/common';
import {  NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ApplicationDetailsComponent } from './components/application-details/application-details.component';
import { ApplicationLeftPanelComponent } from './components/application-left-panel/application-left-panel.component';
import { ApplicationParentListComponent } from './components/application-parent-list/application-parent-list.component';
import { ApplicationSummaryComponent } from './components/application-summary/application-summary.component';
import { ApplicationMainPanelComponent } from './components/application-main-panel/application-main-panel.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { CoreModule } from 'src/app/core/core.module';
import { AddApplicationComponent } from './modals/add-application/add-application.component';
import { UpdateApplicationComponent } from './modals/update-application/update-application.component';
import { UploadFileApplicationComponent } from './modals/upload-file-application/upload-file-application.component';
import { DeleteApplicationComponent } from './modals/delete-application/delete-application.component';
import { BuildFormJsonComponent } from './modals/build-form-json/build-form-json.component';
import { AddFieldComponent } from './modals/build-form-json/add-field/add-field.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { FileEditorForApplicationComponent } from './modals/file-editor-for-application/file-editor-for-application.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SharedModule } from '../shared/shared.module';
import { ApplicationAdvanceViewComponent } from './components/application-advance-view/application-advance-view.component';
import { AngularSplitModule } from 'angular-split';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';

@NgModule({
  declarations: [
    ApplicationDetailsComponent,
    ApplicationLeftPanelComponent,
    ApplicationParentListComponent,
    ApplicationSummaryComponent,
    ApplicationMainPanelComponent,
    AddApplicationComponent,
    UpdateApplicationComponent,
    DeleteApplicationComponent,
    UploadFileApplicationComponent,
    BuildFormJsonComponent,
    AddFieldComponent,
    FileEditorForApplicationComponent,
    ApplicationAdvanceViewComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    CoreModule,
    AngularMaterialModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    ApplicationRoutingModule,
    MatDialogModule,
    NgbModule,
    ResizableModule,
    ClipboardModule,
    SharedModule,
    DynamicPaginationDirective,
    AngularSplitModule
  ]
})
export class ApplicationModule {}
